import React, { useEffect } from 'react';

export default function ToastNotification({ type, message, onClose, duration }) {
  const effectiveDuration = duration ?? (type === 'error' ? 5000 : 3000);

  useEffect(() => {
    const timer = setTimeout(onClose, effectiveDuration);
    return () => clearTimeout(timer);
  }, [onClose, effectiveDuration]);

  return (
    <div
      className={`toast-notification toast-notification--${type ?? 'info'}`}
      role="alert"
      aria-live="polite"
    >
      <span>{message}</span>
      <button
        className="toast-notification__close"
        onClick={onClose}
        aria-label="Fermer la notification"
      >
        ×
      </button>
    </div>
  );
}
